import axios from 'axios';
const user = {
    state: {		
		userDetail : {}				
	},	
	mutations: {		
		userDetail_success(state, payload){
			state.userDetail = payload			
		}		
	},
	actions: {
        getuser({commit, rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Userdetails/Getuser?username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {	
					let payload=respdata;				
					commit('userDetail_success',payload);					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default user